import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d3b4fd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "index-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "descripcion" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Desde esta utilidad podrá consultar la información disponible en el archivo histórico y fotográfico del ayuntamiento de Siero. Por motivos de seguridad, tras realizar la consulta solamente se mostrará un resumen de cada unidad documental inventariada que cumpla los criterios de búsqueda introducidos. Si desea información adicional de una unidad documental concreta, como por ejemplo acceso a los documentos o fotografías que contiene, debe realizar una solicitud formal al archivo municipal del ayuntamiento de Siero. Puede realizar dicha solicitud a través de la sede electrónica "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://sedeelectronica.ayto-siero.es",
      target: "_blank"
    }, "https://sedeelectronica.ayto-siero.es"),
    /*#__PURE__*/_createTextVNode(" o bien a través de cualquiera de las oficinas del registro presencial del ayuntamiento de Siero.")
  ])
], -1))
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { class: "clasificaciones-container" }
const _hoisted_6 = { class: "clasificaciones" }
const _hoisted_7 = { class: "busqueda-exacta" }
const _hoisted_8 = { for: "busqueda-exacta-true" }
const _hoisted_9 = { for: "busqueda-exacta-false" }
const _hoisted_10 = { class: "filtros" }
const _hoisted_11 = { class: "fecha-inicial" }
const _hoisted_12 = { class: "filter-section-title" }
const _hoisted_13 = { class: "desde" }
const _hoisted_14 = { for: "inicial-desde" }
const _hoisted_15 = ["max"]
const _hoisted_16 = { class: "hasta" }
const _hoisted_17 = { for: "inicial-hasta" }
const _hoisted_18 = ["min"]
const _hoisted_19 = { class: "fecha-final" }
const _hoisted_20 = { class: "filter-section-title" }
const _hoisted_21 = { class: "desde" }
const _hoisted_22 = { for: "final-desde" }
const _hoisted_23 = ["max"]
const _hoisted_24 = { class: "hasta" }
const _hoisted_25 = { for: "final-hasta" }
const _hoisted_26 = ["min"]
const _hoisted_27 = { class: "descripcion" }
const _hoisted_28 = {
  class: "filter-section-title",
  for: "descripcion"
}
const _hoisted_29 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_WarningMessage = _resolveComponent("WarningMessage")!
  const _component_LoaderElement = _resolveComponent("LoaderElement")!
  const _component_ClasificacionSelect = _resolveComponent("ClasificacionSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('consulta.consultaInventarioTitulo')), 1),
      _hoisted_3
    ]),
    (_ctx.webServiceError)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('error', { error: _ctx.webServiceError })), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.seleccionarClasificacionError)
      ? (_openBlock(), _createBlock(_component_WarningMessage, { key: 1 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('consulta.seleccionarClasificacionError')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.cargandoClasificaciones)
            ? (_openBlock(), _createBlock(_component_LoaderElement, {
                key: 0,
                class: "loader"
              }))
            : (_openBlock(), _createBlock(_component_ClasificacionSelect, {
                key: 1,
                clasificaciones: _ctx.clasificaciones,
                modelValue: _ctx.clasificacionElegida,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.clasificacionElegida) = $event))
              }, null, 8, ["clasificaciones", "modelValue"]))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.busquedaExacta) = $event)),
              value: true,
              id: "busqueda-exacta-true"
            }, null, 512), [
              [_vModelRadio, _ctx.busquedaExacta]
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('consulta.busquedaExactaClasificacion')), 1)
          ]),
          _createElementVNode("label", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.busquedaExacta) = $event)),
              value: false,
              id: "busqueda-exacta-false"
            }, null, 512), [
              [_vModelRadio, _ctx.busquedaExacta]
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('consulta.noBusquedaExactaClasificacion')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('consulta.fechaInicial')), 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('consulta.desde')), 1),
            _withDirectives(_createElementVNode("input", {
              id: "inicial-desde",
              type: "date",
              max: _ctx.fechaInicialHasta,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fechaInicialDesde) = $event))
            }, null, 8, _hoisted_15), [
              [_vModelText, _ctx.fechaInicialDesde]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('consulta.hasta')), 1),
            _withDirectives(_createElementVNode("input", {
              id: "inicial-hasta",
              type: "date",
              min: _ctx.fechaInicialDesde,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fechaInicialHasta) = $event))
            }, null, 8, _hoisted_18), [
              [_vModelText, _ctx.fechaInicialHasta]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('consulta.fechaFinal')), 1),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('consulta.desde')), 1),
            _withDirectives(_createElementVNode("input", {
              id: "final-desde",
              type: "date",
              max: _ctx.fechaFinalHasta,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fechaFinalDesde) = $event))
            }, null, 8, _hoisted_23), [
              [_vModelText, _ctx.fechaFinalDesde]
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('consulta.hasta')), 1),
            _withDirectives(_createElementVNode("input", {
              id: "final-hasta",
              type: "date",
              min: _ctx.fechaFinalDesde,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fechaFinalHasta) = $event))
            }, null, 8, _hoisted_26), [
              [_vModelText, _ctx.fechaFinalHasta]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('consulta.descripcion')), 1),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            id: "descripcion",
            type: "text",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.descripcion) = $event))
          }, null, 512), [
            [_vModelText, _ctx.descripcion]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("button", {
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
          class: "warning-border"
        }, _toDisplayString(_ctx.$t('consulta.limpiarCriterios')), 1),
        _createElementVNode("button", {
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.buscar && _ctx.buscar(...args))),
          class: "main-border"
        }, _toDisplayString(_ctx.$t('consulta.buscar')), 1)
      ])
    ])
  ]))
}